import { Suspense } from 'react';
import { Plane } from './Plane';
import { SkyEnvironment } from './SkyEnvironment';
import { Clouds } from './Clouds';
import { Runway } from './Runway';
import { Lighting } from './Lighting';
import { GameCamera } from './GameCamera';

interface GameSceneProps {
  debugMode?: boolean;
}

/**
 * Main 3D game scene component
 * Contains sky, clouds, runway, plane, and all visual elements
 */
export function GameScene({ debugMode = false }: GameSceneProps): React.JSX.Element {
  return (
    <>
      {/* Camera controls */}
      <GameCamera enableOrbitControls={debugMode} />

      {/* Lighting */}
      <Lighting showHelpers={debugMode} />

      {/* Sky environment */}
      <Suspense fallback={null}>
        <SkyEnvironment sunPosition={[100, 50, 100]} turbidity={6} rayleigh={0.5} />
      </Suspense>

      {/* Clouds */}
      <Clouds />

      {/* Runway and ground */}
      <Runway />

      {/* Aircraft */}
      <Plane startPosition={[-10, 2, 0]} speed={1} />

      {/* Fog for depth (light blue aviation haze) */}
      <fog attach="fog" args={['#b0d4e8', 40, 150]} />
    </>
  );
}
